import { ArrowLeftOutlined, HddOutlined } from "@ant-design/icons";
import { Fragment, ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LinkOrSpan from "../links/LinkOrSpan/LinkOrSpan";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./PageHeaderNew.module.scss";

export interface Breadcrumb {
  label: string;
  url?: string;
  icon?: React.ReactNode;
}

export const COLLECTING_BREADCRUMB: Breadcrumb = {
  label: "Collecting",
  url: "/",
  icon: <HddOutlined />,
};

export function PageHeaderNew({
  title,
  breadcrumbs,
  description,
  children,
  loading,
  breadcrumbsRight,
  titleRight,
  extraTop,
}: {
  title?: string;
  breadcrumbs?: Breadcrumb[];
  children?: ReactNode;
  description?: ReactNode;
  loading?: boolean;
  breadcrumbsRight?: ReactNode;
  titleRight?: ReactNode;
  extraTop?: ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (title) {
      window.document.title = title + " · Root Sustainability";
    }
  }, [title]);

  return (
    <div className={styles.PageHeader}>
      <div className={styles.topbar}>
        <div className={styles.breadcrumbs}>
          <div className={styles.arrows}>
            <LinkOrSpan
              onClick={
                location.key !== "default"
                  ? () => {
                      navigate(-1);
                    }
                  : undefined
              }
              className={`${styles.arrow} ${location.key !== "default" ? styles.active : ""}`}
            >
              <ArrowLeftOutlined />
            </LinkOrSpan>
          </div>
          <div className={styles.breadcrumbsContainer}>
            {breadcrumbs?.map((breadcrumb, index) => (
              <Fragment key={index}>
                <LinkOrSpan
                  to={breadcrumb.url}
                  className={styles.breadcrumb}
                >
                  {breadcrumb.icon}
                  {breadcrumb.label}
                </LinkOrSpan>
                {index < breadcrumbs.length - 1 && <span className={styles.separator}>/</span>}
              </Fragment>
            ))}
          </div>
        </div>
        {breadcrumbsRight}
      </div>
      <div>
        {extraTop}
        <div className={styles.header}>
          <div className={styles.title}>
            <h1>{loading ? <Skeleton style={{ width: "200px", height: "36px" }} /> : title}</h1>
            {titleRight && <div className={styles.right}>{titleRight}</div>}
          </div>
          {children && <div className={styles.body}>{children}</div>}
          {description && <p>{description}</p>}
        </div>
      </div>
    </div>
  );
}
